import { Navigate, useLocation } from 'react-router-dom';
import { UserStatus, type UserRole } from '@teentack/shared';
import { useAuth } from './use-auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** When set, the signed-in user must hold one of these roles. [FR-M01.4] */
  roles?: UserRole[];
  /**
   * When true, a PENDING account (e.g. a teen awaiting guardian approval) is
   * sent to the holding page instead of the route. [FR-M01.2]
   */
  requireActive?: boolean;
}

export function ProtectedRoute({ children, roles, requireActive = true }: ProtectedRouteProps) {
  const { user, initializing } = useAuth();
  const location = useLocation();

  if (initializing) {
    return <p className="p-10 text-slate-500">Loading…</p>;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (requireActive && user.status !== UserStatus.ACTIVE) {
    return <Navigate to="/pending" replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
